import JSONFieldEditorComponent from './json-field-editor';

export default JSONFieldEditorComponent;

export { JSONFieldEditor } from './json-field-editor';

export type {
  BaseFieldEditorProps,
  JSONFieldEditorPlugin,
  AnyJSONFieldEditorPlugin,
  JSONFieldEditorProps,
  AnyJSONFieldEditorProps,
} from './types';
